import { Form as FormInitial, Row, Col, Space, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
  FormItem,
  InputItem,
  Form,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import prorrateosPdf from "../../../../Pdf/prorrateosPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarCorreoProrrateo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf: null,
    };
    this.formRef = React.createRef();
    this.cerrarMandarCorreoProrrateo = this.cerrarMandarCorreoProrrateo.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarTodo();
    }
  }

  async consultarTodo() {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "prorrateo/datosProrrateo",
        { empresaId: this.props.empresaId, prorrateoId: this.props.id },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const pdf = pdfMake.createPdf(prorrateosPdf(res.data));
        this.setState({ loading: false, pdf }, () => {
          pdf.open({}, window.frames["prorrateosPdf"]);
        });
      } else {
        message.error("Error al obtener datos del prorrateo");
        this.setState({ loading: false });
      }
    } catch {
      message.error("Error al cargar el prorrateo");
      this.setState({ loading: false });
    }
  }

  async descargarPdf() {
    if (this.state.pdf) {
      this.state.pdf.download(`Prorrateo_${this.props.id}.pdf`);
      return;
    }
    try {
      const res = await axios.post(
        "prorrateo/datosProrrateo",
        { empresaId: this.props.empresaId, prorrateoId: this.props.id },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        pdfMake.createPdf(prorrateosPdf(res.data)).download(`Prorrateo_${this.props.id}.pdf`);
      }
    } catch {
      message.error("Error al descargar el PDF");
    }
  }

  cerrarMandarCorreoProrrateo() {
    this.setState({ pdf: null });
    if (this.formRef.current) this.formRef.current.resetFields();
    this.props.cerrarMandarCorreoProrrateo();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!values?.correosEnvio?.length) {
      message.info("Proporcione al menos un correo de envío");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "prorrateo/enviarProrrateo",
        { ...values, prorrateoId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Prorrateo enviado");
          this.cerrarMandarCorreoProrrateo();
        } else if (res.data.success === 1) {
          message.error("No se pudo enviar el prorrateo a ese correo");
        } else {
          message.error("Sucedió un error y no se pudo enviar");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al enviar el correo");
      });
  }

  render() {
    return (
      <ModalItem
        title="Vista previa — Prorrateo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarCorreoProrrateo}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoProrrateo"
          layout
          width={700}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 && (
                  <div style={{ textAlign: "center", marginTop: 5 }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                )}
              </>
            )}
          </FormInitial.List>

          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem icon={<DownloadOutlined />} blanco onClick={() => this.descargarPdf()}>
                Descargar
              </ButtonItem>
              <ButtonItem type="primary" htmlType="submit">
                Mandar Correo
              </ButtonItem>
              <ButtonItem type="primary" danger onClick={this.cerrarMandarCorreoProrrateo}>
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>

        <iframe
          title="Prorrateo PDF"
          style={{ width: "100%", height: "100vh" }}
          id="prorrateosPdf"
          name="prorrateosPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(MandarCorreoProrrateo);
